// extracted by mini-css-extract-plugin
module.exports = {"uploadButton":"index_uploadButton__3FcIS","uploadButton_tip":"index_uploadButton_tip__2RDff","tip":"index_tip__31TyG","videoTip":"index_videoTip__3uYmA"};